export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="lg:col-span-2">
            <span className="text-xl font-heading text-primary-400 whitespace-nowrap">今日吃瓜</span>
            <p className="text-sm text-background-50/60 mt-3 leading-relaxed max-w-md">
              今日吃瓜是专注热点事件汇总与追踪的内容平台。每日必吃大瓜、热门大瓜必看、今日吃瓜事件一站式追踪。
              覆盖娱乐、网红、社会、电竞等多元领域，为吃瓜群众提供最全面的热点资讯服务。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#hero" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center text-background-50/60 hover:text-background-50 hover:bg-primary-500 transition-all cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center text-background-50/60 hover:text-background-50 hover:bg-primary-500 transition-all cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center text-background-50/60 hover:text-background-50 hover:bg-primary-500 transition-all cursor-pointer">
                <i className="ri-vidicon-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading text-background-50 mb-4 whitespace-nowrap">快速导航</h4>
            <nav className="flex flex-col gap-2.5">
              <a href="#carousel" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">焦点大瓜</a>
              <a href="#updates" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">实时快讯</a>
              <a href="#topics" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热门话题</a>
              <a href="#ranking" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">大瓜榜单</a>
              <a href="#faq" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-heading text-background-50 mb-4 whitespace-nowrap">合作伙伴</h4>
            <p className="text-sm text-background-50/40 leading-relaxed">
              内容合作与媒体伙伴持续拓展中，欢迎优质内容创作者加入我们的大瓜生态。
            </p>
          </div>
        </div>

        <div className="pt-8 border-t border-background-50/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; 2026 今日吃瓜 - 热门大瓜汇总，每日必吃。本站内容仅供信息参考，不构成任何建议。
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap cursor-pointer">关于我们</a>
              <a href="#hero" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap cursor-pointer">免责声明</a>
              <a href="#contact" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}